module.exports = __webpack_public_path__ + "fonts/Quicksand-400-vietnamese4.acc5504.woff2";